import React from 'react';

export interface SkeletonProps extends React.HTMLAttributes<HTMLDivElement> {
  rounded?: 'sm' | 'md' | 'lg' | 'xl' | '2xl' | 'full';
}

export function Skeleton({ rounded = 'xl', className = '', ...props }: SkeletonProps) {
  const roundedClass = `rounded-${rounded}`;

  return (
    <div
      className={`bg-surface-container-high animate-pulse ${roundedClass} ${className}`}
      {...props}
    />
  );
}
